/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
 
import { IconDownload, IconEye, IconPlus } from "@tabler/icons-react";
import NormalSearch from "../../../components/common/NormalSearch";
import DropdownFilter from "../../../components/common/DropdownFilter";
import ColumnsFilter from "../../../components/common/ColumnsFilter";
import ListView from "../../../components/common/ListView";
import { useNavigate } from "react-router-dom";
import ToggleButton from "../../../components/ToggleButton";

import {
  useFetchProductItemData,
  useUpdateProductItemStatus,
} from "../../../apis/productApis";

import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import MessageModal from "../../../components/MessageModal";
import EntriesSelector from "../../../components/common/EntriesSelector";
import NoDataFound from "../../../components/common/NoDataFound";
import TableSkeleton from "../../../components/skeleton/TableSkeleton";
import Pagination from "../../../components/common/Pagination";
import useDebounce from "../../../utilities/useDebounce";
import { useSelector } from "react-redux";

 

export default function ItemInventory() {
  const navigate = useNavigate();
  const [pageNo, setPageNo] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);
  const [searchFor, setSearchFor] = useState<string>("");
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [actionModal, setActionModal] = useState<boolean>(false);

  const { isLoading, isFetching, error, refetch } = useFetchProductItemData(
    pageNo,
    limit,
    searchFor
  );

  const data = useSelector((state: any) => state?.product?.data);

  const { mutate: updateProductStatus, isPending: statusPending } =
    useUpdateProductItemStatus();

  const handleToggleStatus = (item: any) => {
    setSelectedItem(item);
    setActionModal(true);
  };

  const confirmUpdateStatus = async () => {
    const newStatus = selectedItem?.status === "ACTIVE" ? "INACTIVE" : "ACTIVE";

    updateProductStatus(
      { id: selectedItem?.id, status: newStatus },
      {
        onSuccess: () => {
          refetch();
          toast.success("Status updated successfully");
          setActionModal(false);
        },
        onError: (error:any) => {
          toast.error(`${error}`);
        },
      }
    );
  };
  const debouncedSearchFor = useDebounce(searchFor, 550);

  useEffect(() => {
    refetch();
  }, [pageNo, limit, debouncedSearchFor]);

  const handlePaginationFetch = (page: number) => {
    setPageNo(page);
  };

  const [columnsData, setColumnsData] = useState([
    { text: "S/N", value: "sn", isShow: true },
    { text: "Item Type", value: "itemType", isShow: true },
    { text: "Item Name	", value: "itemName", isShow: true },
    { text: "SKU", value: "sku", isShow: true },
    { text: "Warehouse", value: "warehouse", isShow: true },
    { text: "Storage Type", value: "storageType", isShow: true },
    { text: "Shelve ID", value: "shelveID", isShow: true },
    { text: "Qty", value: "qty", isShow: true },
    { text: "Status", value: "status", isShow: true },
    { text: "Expiry Days", value: "expiryDays", isShow: true },
    { text: "Actions", value: "actions", isShow: true },
  ]);

  const setHeadings = (value: string | undefined, checked: boolean) => {
    setColumnsData((prev) =>
      prev.map((col) =>
        col.value === value ? { ...col, isShow: checked } : col
      )
    );
  };

  const columns = columnsData
    .filter((c) => c.isShow)
    .map((col) => {
      switch (col.value) {
        case "sn":
          return {
            label: "#",
            render: (_: any, i: number) => (pageNo - 1) * limit + (i + 1),
          };
        case "itemType":
          return {
            label: "Item Type",
            render: (c: any, index: any) => (
              <div className="flex">
                <span
                  key={index}
                  title={c.itemName}
                  className={` px-3 py-1 rounded-full text-white  ${
                    index % 2 === 0 ? "bg-green-500  " : "bg-blue-500"
                  } "`}
                >
                  {index % 2 === 0 ? "B2C" : "B2B"}
                </span>
              </div>
            ),
          };
        case "itemName":
          return {
            label: "Item Name",
            render: (c: any) => (
              <div className="flex items-center space-x-3 truncate max-w-xs">
                <img
                  alt=""
                  src={
                    "https://assets.clevelandclinic.org/transform/LargeFeatureImage/cd71f4bd-81d4-45d8-a450-74df78e4477a/Apples-184940975-770x533-1_jpg"
                  }
                  className="size-12 rounded-md object-cover object-center "
                />
                <span title={c.itemName} className="truncate w-20">
                  {c.itemName}
                </span>
              </div>
            ),
          };

        case "sku":
          return {
            label: "SKU",
            render: (c: any) => <div>{"SKU001"}</div>,
          };
        case "warehouse":
          return {
            label: "Warehouse",
            render: (c: any) => c.warehouse,
          };
        case "storageType":
          return {
            label: "Storage Type",
            render: (c: any) => c.storageType,
          };

        case "shelveID":
          return {
            label: "Shelve Id",
            render: (c: any) => <div>{"SHELF001"}</div>,
          };
        case "qty":
          return {
            label: "Qty",
            render: (c: any) => c.capacity,
          };

        case "expiryDays":
          return {
            label: "Expiry Days",
            render: (c: any) => <div>12 Days</div>,
          };
        case "status":
          
          return {
            label: "Expiry Status",
            render: (c: any) => (
              <div className="flex justify-start">
                <ToggleButton
                  onChange={() => handleToggleStatus(c)}
                  checked={c.status === "ACTIVE"}
                />
              </div>
            ),
          };
        case "actions":
          return {
            label: "Actions",
            render: (item: any) => (
              <div className="text-center">
                <button
                  onClick={() => navigate(`/add-item/${item.id}`)}
                  className="p-2 border rounded-full bg-[#F7F6F2]"
                >
                  <IconEye size={22} />
                </button>
              </div>
            ),
          };
        default:
          return { label: "", render: () => null };
      }
    });

  return (
    <>
      <div className="">
        <div className="flex items-center">
          <div className=" bg-[#F7F6F2] flex items-center justify-between px-6 py-3 w-full rounded-tl-3xl rounded-tr-[40px] ">
            <h1 className="text-xl text-[#212121] tracking-[-0.5px] font-medium">
              Item Inventory
            </h1>
            <div className="flex items-center gap-2">
              {data && data.totalPages * limit > 10 && (
                <EntriesSelector
                  value={limit}
                  options={[
                    10,
                    ...(data.totalPages * limit > 10 ? [20] : []),
                    ...(data.totalPages * limit > 20 ? [30] : []),
                    ...(data.totalPages * limit > 50 ? [50] : []),
                    ...(data.totalPages * limit > 100 ? [100] : []),
                  ]}
                  onChange={(val) => {
                    setLimit(val);
                    setPageNo(1);
                  }}
                />
              )}
              <ColumnsFilter
                columnsData={columnsData}
                setHeadings={setHeadings}
              />
              <DropdownFilter filterheadings={[]} />
              <NormalSearch
                value={searchFor}
                onChange={(e) => {
                  setSearchFor(e.target.value);
                  setPageNo(1);
                }}
              />
            </div>
          </div>
          <div className="relative ml-5">
            <div className=" flex items-center gap-2 justify-end rounded-full">
              <button className="flex items-center gap-1 p-2.5 text-sm rounded-full border border-[#FFFFFF] bg-[#F7F6F2]">
                <IconDownload stroke={1.5} size={24} />
              </button>

              {/* <button
                onClick={() => navigate("/add-item")}
                className="flex items-center gap-1  p-2.5 text-sm rounded-full border border-[#FFFFFF] bg-[#F7F6F2]"
              >
                <IconPlus stroke={1.5} size={24} />
              </button> */}
            </div>
          </div>
        </div>
        <div>
          {isLoading || isFetching ? (
            <TableSkeleton
              columns={columnsData.filter((c) => c.isShow).map((c) => c.text)}
              rows={6}
            />
          ) : data?.productItems?.length ? (
            <ListView data={data?.productItems} columns={columns} />
          ) : (
            <NoDataFound />
          )}
        </div>

        <div className="flex justify-center items-center py-4">
          {data?.totalPages > 1 && (
            <Pagination
              currentPage={pageNo}
              totalPages={data?.totalPages}
              fetchData={handlePaginationFetch}
            />
          )}
        </div>
      </div>
      <MessageModal
        open={actionModal}
        onClose={() => setActionModal(false)}
        title="Confirmation Required"
        subtitle="Are you sure you want to perform this action?"
        img={
          selectedItem?.status === "ACTIVE"
            ? "/img/inactive.svg"
            : "/img/active.svg"
        }
        showFooter={true}
        closeButtonText="Cancel"
        actionButtonText="Confirm"
        actionButtonOnClick={confirmUpdateStatus}
        isPending={statusPending}
        size="md"
      />
    </>
  );
}
